import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateWorkflowCache,
  WorkflowCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/workflowCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type useWorkflowUpdateParams = {
  config?: MutationConfig<Api.UpdateWorkflowResponse, Api.ErrorResponse>;
};

export const useWorkflowUpdate = (params?: useWorkflowUpdateParams) =>
  useMutation(Api.updateWorkflow, {
    ...params?.config,
    onSuccess: (updatedWorkflow, mutationFuncParams) => {
      const { organizationId } = mutationFuncParams;
      const keyParams = { organizationId, workflowId: updatedWorkflow.id };

      // Invalidate any RQ cache that might depend on the existing workflow
      invalidateWorkflowCache(WorkflowCacheEvents.UPDATE, keyParams);

      return params?.config?.onSuccess?.(updatedWorkflow, mutationFuncParams);
    },
  });
